import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, PopoverController, ViewController, AlertController, ModalController } from 'ionic-angular';
import firebase from 'firebase/app';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { ViewContactPdfPage } from '../view-contact-pdf/view-contact-pdf';
import { LoadingProvider } from '../../providers/loading/loading';
import { StepformPage } from '../stepform/stepform';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AllowCustomerPermissionPage } from '../allow-customer-permission/allow-customer-permission';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { HistoryDetailsPage } from '../history-details/history-details';
import { ViewMoreAddressPage } from '../view-more-address/view-more-address';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { AngularFireAuth } from 'angularfire2/auth';
import RealEstatePage from '../real-estate/real-estate';
import {EnvDataService} from '../../app/services/env-data-service';
export interface Image {
  id: string;
  image: string;
}
@Component({
  selector: 'page-view-contact',
  templateUrl: 'view-contact.html',
  providers:[EnvDataService]
})
export class ViewContactPage {

  /*Request form*/
  url: any;
  newImage: Image = {
    id: this.db.createId(), image: ''
  }
  loading: boolean = false;
  /*End Request form*/

  updateEmailPhoneForm: FormGroup;
  updateEmailPhoneFormSec: FormGroup;
  ReviewByCustomer: FormGroup;
  public userAccessEdit: any;
  public userAccessView: any;
  public usersDetails : any;
  public contact_uid: any;
  public singleUserDetails: any;
  public unique_key: any;
  public user_data: any;
  public employment: any;
  public incomes: any;
  public incomesSec: any;
  public assets: any;
  public assetsSec: any;
  public primary_tag : any;
  public secondary_tag : any;
  public liabilities: any;
  public liabilitiesSec: any;
  public realestates: any;
  public tentativerealestates : any;
  public tentativerealestatesa : any;
  public tentativerealestatesaa : any;
  public total_current_balance : any;
  public total_mortgage_limit : any;
  public total_asset_value : any;
  public total_available_redraw : any;
  public total_repayments : any;
  public total_annual_repayments_limit : any;
  public total_gross_amount : any;
  public total_rent_annual : any;
  public total_lvr : any;
  public total_tentative_current_balance : any;
  public total_tentative_current_balance1 : any;
  public total_tentative_mortgage_limit : any;
  public total_tentative_mortgage_limit1 : any;
  public total_tentative_asset_value : any;
  public total_tentative_asset_value1 : any;
  public total_tentative_available_redraw : any;
  public total_tentative_available_redraw1 : any;
  public total_tentative_repayments : any;
  public total_tentative_repayments1 : any;
  public total_tentative_annual_repayments_limit : any;
  public total_tentative_annual_repayments_limit1 : any;
  public total_tentative_gross_amount : any;
  public total_tentative_gross_amount1 : any;
  public total_tentative_rent_annual : any;
  public total_tentative_rent_annual1 : any;
  public total_tentative_lvr : any;
  public total_tentative_lvr1 : any;
  public userRole: any;
  public accessPermissionStatus: any;
  public showDetails : any;
  public icon : any;
  public accessPermissioncheckstatus : any;
  public accessPermissionname : any;
  public accessPermissioncheckstatusPS : any;
  public accessPermissionnamePS : any;
  public primary_secondary_contact_uid: any;
  public primSecondContact: any;
  public primSecondEmployment: any;
  public trenumber : number;
  public document_id : any;
  submitAttempt: boolean = false;
  public agreed : any;
  public accessGrantedFromUserstatus: number;
  public assigned_broker_name: any;
  public annual_repayments_limit1:any;
  public annual_repayments_limit2:any;
  public realestateSplits: any;
  public split_current_balance : any;
  public split_mortgage_limit : any;
  public split_available_redraw: any;
  public split_repayments : any;
  public split_interest_rate : any;
  public split_creditor : any;
  public split_interest_rate_term : any;
  public split_loan_type : any;
  public split_tentative_creditor : any;
  public split_tentative_interest_rate_term : any;
  public split_tentative_loan_type : any;
  public showCurrentTentativetable: any = false;
  public showCurrentTentativetableIndex : any;

  public tentative_annual_repayments_limit1:any;
  public tentative_annual_repayments_limit2:any;
  public tentative_realestateSplits: any;
  public split_tentative_current_balance : any;
  public split_tentative_mortgage_limit : any;
  public split_tentative_repayments : any;
  public split_tentative_interest_rate : any;
  public primary_secondary_found: any;
  public editPhoneOption : number = 0;
  public editEmailOption: number = 0;

  public editPhoneOptionSecond : number = 0;
  public editEmailOptionSecond: number = 0;
  public tentativerealestatesGroup : any;
  public showHideTentativetable : any;
  public showHideLeaderAddressRealestate : any;
  public showHideLeaderAssetValueRealestate : any;
  public showHideLeaderOwnershipTitleNameRealestate : any;
  public showHideLeaderRentAnnualRealestate : any;
  public showHideLeaderGrossAmountRealestate : any;
  public showHideLeaderCreditorRealestate : any;
  public showHideLeaderMortgageLimitRealestate : any;
  public showHideLeaderCurrentBalanceRealestate : any;
  public showHideLeaderIntrestRateRealestate : any;
  public showHideLeaderInterestRateTermRealestate : any;
  public showHideLeaderLoanTypeRealestate : any;
  public showHideLeaderRepaymentsRealestate : any;

  public showHideLeaderAddressTentaRealestate : any;
  public showHideLeaderAssetValueTentaRealestate : any;
  public showHideLeaderOwnershipTitleTentaRealestate : any;
  public showHideLeaderRentAnnualTentaRealestate : any;
  public showHideLeaderGrossAmountTentaRealestate : any;
  public showHideLeaderCreditorTentaRealestate : any;
  public showHideLeaderMortgageLimitTentaRealestate : any;
  public showHideLeaderCurrentBalanceTentaRealestate : any;
  public showHideLeaderIntrestRateTentaRealestate : any;
  public showHideLeaderInterestRateTermTentaRealestate : any;
  public showHideLeaderLoanTypeTentaRealestate : any;
  public showHideLeaderRepaymentsTentaRealestate : any;

  public assets_data: any;
  public liabilities_data: any;
  public realEstate_data: any;
  public second_contact_data: any;
  public second_employment_data: any;
  public second_income_data: any;
  public second_asset_data: any;
  public second_liabilities_data: any;
  public userData: any;

  public all_documents: any;
  public percentage: any;
  public percentageArea: any;
  public priSec_uid: any;
  public approval_log: any;
  public approval_log_data: any;
  public user_history: any;
  public SDF_form_document_id: any;
  public secondary_applicant: any;

  public validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http : Http,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public formBuilder: FormBuilder,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    private storage: AngularFireStorage,
    public SdfFormService: SdfFormService,
    public afAuth: AngularFireAuth,
    public modalCtrl: ModalController,
    private EnvDataService:EnvDataService
  ) {

    debugger;

    this.afAuth.authState.subscribe(data => {
      let thiss = this;
      var docRef = firebase.firestore().collection("users").doc(data.uid);
      docRef.get().then(function(doc) {
        if (doc.exists) {
          let user_data = doc.data();
          if(user_data.roles.super_admin){
            thiss.userRole = 'super_admin';
            window.localStorage.setItem("userRole", 'super_admin');
            window.localStorage.setItem("deleted_access", user_data.deleted_access);  
          }else if(user_data.roles.broker){
            thiss.userRole = 'broker';
            window.localStorage.setItem("userRole", 'broker');
          }else if(user_data.roles.loan_admin){
            thiss.userRole = 'loan_admin';
            window.localStorage.setItem("userRole", 'loan_admin');
          }else{
            thiss.userRole = 'contact';
            window.localStorage.setItem("userRole", 'contact');
          }
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
    });

    /*Request form*/
    this.all_documents = [];
    /*End Request form*/

    window.localStorage.removeItem("creating_second");
    this.user_data = '';
    this.employment = '';
    let thiss = this;
    this.trenumber = 1;
    this.total_tentative_current_balance1 = [];
    this.total_tentative_mortgage_limit1 = [];
    this.total_tentative_asset_value1 = [];
    this.total_tentative_available_redraw1 = [];
    this.total_tentative_repayments1 = [];
    this.total_tentative_annual_repayments_limit1 = [];
    this.total_tentative_gross_amount1 = [];
    this.total_tentative_rent_annual1 = [];
    this.total_tentative_lvr1 = [];
    this.primSecondContact = 0;
    this.primSecondEmployment = 0;
    this.accessGrantedFromUserstatus = 0;
    this.approval_log = '';
    //this.approval_log_data = [];

    this.userRole = window.localStorage.getItem("userRole");
    let createdContact_uid = window.localStorage.getItem("contact_uid");
    let uid = window.localStorage.getItem("uid");
    this.contact_uid = this.navParams.get("contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let contactUid = location.search.split('id=')[1];
    this.document_id = location.search.split('&docId=')[1];
    this.ReviewByCustomer = formBuilder.group({
      agreed: ['']
    });

    if(this.SDF_form_document_id == undefined || this.SDF_form_document_id == null || this.SDF_form_document_id == ''){
      this.SDF_form_document_id = window.localStorage.getItem("SDF_form_document_id");
    }

    if(this.document_id != undefined){
      contactUid = contactUid.split('&docId=')[0];
    }
    if(contactUid == "" || contactUid == null || contactUid == undefined){}else{
      this.contact_uid = contactUid;
    }

    if(this.contact_uid == "" || this.contact_uid == null || this.contact_uid == undefined){
      if(createdContact_uid == "" || createdContact_uid == null || createdContact_uid == undefined){}else{
        this.contact_uid = createdContact_uid;
      }
    }
    if(window.localStorage.getItem("userRole") == "contact"){
      this.contact_uid = window.localStorage.getItem("uid");
    }

    thiss.userAccessEdit = 0;
    thiss.userAccessView = 0;

    if(thiss.SDF_form_document_id != undefined){

      let SDF_form = firebase.firestore().collection("SDF_form").doc(thiss.SDF_form_document_id);
      SDF_form.get().then(function(SDF_form_doc) {
        if (SDF_form_doc.exists) {
          let sdf_data = SDF_form_doc.data();
          let main_uid = sdf_data.uid;
          let docRef1 = firebase.firestore().collection("users").doc(main_uid);
          docRef1.get().then(function(doc) {
            if (doc.exists) {
              thiss.user_data = doc.data();
              thiss.get_user_data(main_uid, thiss.SDF_form_document_id).subscribe((get_user_data)=>{
                if(get_user_data.length > 0){
                  thiss.user_data = get_user_data[0];
                  thiss.user_data.accessGrantedFromUser = get_user_data[0].accessGrantedFromUser;
                  thiss.accessGrantedFromUserstatus = thiss.user_data.accessGrantedFromUser;
                  if(uid == thiss.user_data.uid){
                    thiss.userAccessEdit = (thiss.user_data.allowCustoeditPermission == undefined) ? 0 : thiss.user_data.allowCustoeditPermission;
                    thiss.userAccessView = (thiss.user_data.allowCustoViewOnlyPermission == undefined) ? 0 : thiss.user_data.allowCustoViewOnlyPermission;
                  }
                  thiss.user_data.email = doc.data().email;
                  thiss.user_data.mobile_phone = doc.data().mobile_phone;
                  firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", main_uid).get()
                  .then(function(querySnapshot2) {
                    querySnapshot2.forEach(function(empDoc) {
                      thiss.employment = empDoc.data();
                    });
                  })

                  thiss.SdfFormService.get_second_user_data(thiss.SDF_form_document_id)
                  .then((get_second_user_data) => {
                    thiss.secondary_applicant = [];
                    Object.keys(get_second_user_data).forEach(function(key) {
                      var secondUser = firebase.firestore().collection("users").doc(get_second_user_data[key].uid);
                      secondUser.get().then(function(secdoc) {
                        if (secdoc.exists) {
                          if(uid == get_second_user_data[key].uid){
                            thiss.userAccessEdit = (get_second_user_data[key].allowCustoeditPermission == undefined) ? 0 : get_second_user_data[key].allowCustoeditPermission;
                            thiss.userAccessView = (get_second_user_data[key].allowCustoViewOnlyPermission == undefined) ? 0 : get_second_user_data[key].allowCustoViewOnlyPermission;
                          }
                          firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", get_second_user_data[key].uid).get()
                          .then(function(querySnapshotEmp) {
                            querySnapshotEmp.forEach(function(empDoc1) {
                              thiss.secondary_applicant.push({'employment': empDoc1.data(), 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
                            })
                            if(querySnapshotEmp.empty){
                              thiss.secondary_applicant.push({'employment': [], 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
                            }
                          });
                        }
                      });
                    })
                  })
                }
              });
              thiss.get_incomes(sdf_data.id).subscribe((get_incomes)=>{
                if(get_incomes.length > 0){
                  thiss.incomes = get_incomes
                  Object.keys(get_incomes).forEach(function(key) {
                    thiss.get_owner(get_incomes[key].SDF_form, get_incomes[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.incomes[key].firstname = get_owner[0].firstname;
                        thiss.incomes[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_assets(sdf_data.id).subscribe((get_assets)=>{
                if(get_assets.length > 0){
                  thiss.assets = get_assets
                  Object.keys(get_assets).forEach(function(key) {
                    thiss.get_owner(get_assets[key].SDF_form, get_assets[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.assets[key].firstname = get_owner[0].firstname;
                        thiss.assets[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_liabilities(sdf_data.id).subscribe((get_liabilities)=>{
                if(get_liabilities.length > 0){
                  thiss.liabilities = get_liabilities
                  Object.keys(get_liabilities).forEach(function(key) {
                    thiss.get_owner(get_liabilities[key].SDF_form, get_liabilities[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.liabilities[key].firstname = get_owner[0].firstname;
                        thiss.liabilities[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_realEstates(sdf_data.id).subscribe((get_realEstates)=>{
                if(get_realEstates.length > 0){
                  thiss.total_current_balance = parseInt('0');
                  thiss.total_mortgage_limit = parseInt('0');
                  thiss.total_asset_value = parseInt('0');
                  thiss.total_available_redraw = parseInt('0');
                  thiss.total_repayments = parseInt('0');
                  thiss.total_annual_repayments_limit = parseInt('0');
                  thiss.total_gross_amount = parseInt('0');
                  thiss.total_rent_annual = parseInt('0');
                  thiss.total_lvr = parseInt('0');
                  thiss.realestateSplits = [];
                  thiss.showHideLeaderAddressRealestate = [];
                  thiss.showHideLeaderAssetValueRealestate = [];
                  thiss.showHideLeaderOwnershipTitleNameRealestate = [];
                  thiss.showHideLeaderRentAnnualRealestate = [];
                  thiss.showHideLeaderGrossAmountRealestate = [];

                  thiss.showHideLeaderCreditorRealestate = [];
                  thiss.showHideLeaderMortgageLimitRealestate = [];
                  thiss.showHideLeaderCurrentBalanceRealestate = [];
                  thiss.showHideLeaderIntrestRateRealestate = [];
                  thiss.showHideLeaderInterestRateTermRealestate = [];
                  thiss.showHideLeaderLoanTypeRealestate = [];
                  thiss.showHideLeaderRepaymentsRealestate = [];

                  let showHideLeaderCreditorRealestate = [];
                  let showHideLeaderMortgageLimitRealestate = [];
                  let showHideLeaderCurrentBalanceRealestate = [];
                  let showHideLeaderIntrestRateRealestate = [];
                  let showHideLeaderInterestRateTermRealestate = [];
                  let showHideLeaderLoanTypeRealestate = [];
                  let showHideLeaderRepaymentsRealestate = [];

                  thiss.realestates = get_realEstates;
                  get_realEstates.forEach(function (value, index) {
                    thiss.showHideLeaderAddressRealestate.push(0);
                    thiss.showHideLeaderAssetValueRealestate.push(0);
                    thiss.showHideLeaderOwnershipTitleNameRealestate.push(0);
                    thiss.showHideLeaderRentAnnualRealestate.push(0);
                    thiss.showHideLeaderGrossAmountRealestate.push(0);
                    
                    thiss.split_current_balance = parseInt('0');
                    thiss.split_mortgage_limit = parseInt('0');
                    thiss.split_available_redraw = parseInt('0');
                    thiss.split_repayments = parseInt('0');
                    thiss.annual_repayments_limit1 = parseInt('0');
                    thiss.annual_repayments_limit2 = parseInt('0');
                    thiss.split_interest_rate = parseFloat('0');
                    if(value.split.length > 0){
                      showHideLeaderCreditorRealestate = [];
                      showHideLeaderMortgageLimitRealestate = [];
                      showHideLeaderCurrentBalanceRealestate = [];
                      showHideLeaderIntrestRateRealestate = [];
                      showHideLeaderInterestRateTermRealestate = [];
                      showHideLeaderLoanTypeRealestate = [];
                      showHideLeaderRepaymentsRealestate = [];
                      value.split.forEach(function (value2, key2) {
                        showHideLeaderCreditorRealestate.push(0);
                        showHideLeaderMortgageLimitRealestate.push(0);
                        showHideLeaderCurrentBalanceRealestate.push(0);
                        showHideLeaderIntrestRateRealestate.push(0);
                        showHideLeaderInterestRateTermRealestate.push(0);
                        showHideLeaderLoanTypeRealestate.push(0);
                        showHideLeaderRepaymentsRealestate.push(0);
                        thiss.split_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        thiss.split_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                        thiss.split_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                        thiss.split_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
                        thiss.split_interest_rate += parseFloat(value2.interest_rate);
                        thiss.split_creditor = value2.creditor;
                        thiss.split_loan_type = value2.loan_type;
                        thiss.split_interest_rate_term = value2.interest_rate_term;

                        let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        let IR = parseFloat(value2.interest_rate);

                        thiss.annual_repayments_limit1 += ((CB)*(IR/100));

                        thiss.realestates[index].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        thiss.realestates[index].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                        thiss.realestates[index].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                        thiss.realestates[index].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
                      });

                      thiss.realestates[index].creditor = thiss.split_creditor;
                      thiss.realestates[index].interest_rate_term = thiss.split_interest_rate_term;
                      thiss.realestates[index].loan_type = thiss.split_loan_type;
                      thiss.realestates[index].mortgage_limit = thiss.split_mortgage_limit;
                      thiss.realestates[index].available_redraw = thiss.split_available_redraw;
                      thiss.realestates[index].current_balance = thiss.split_current_balance;
                      thiss.realestates[index].repayments = thiss.split_repayments;
                      thiss.realestates[index].interest_rate = thiss.split_interest_rate;
                      //thiss.realestates[index].available_redraw = thiss.split_mortgage_limit - thiss.split_current_balance;
                      thiss.realestates[index].lvr = ((thiss.split_current_balance/parseInt(value.asset_value))*100).toFixed(2);

                      thiss.total_current_balance += parseInt(thiss.split_current_balance);
                      thiss.total_mortgage_limit += parseInt(thiss.split_mortgage_limit);
                      thiss.total_asset_value += parseInt(value.asset_value);
                      thiss.total_available_redraw += parseInt(thiss.split_available_redraw);
                      //thiss.total_available_redraw += parseInt(thiss.split_mortgage_limit) - parseInt(thiss.split_current_balance);
                      thiss.total_repayments += parseInt(thiss.split_repayments);
                      thiss.total_gross_amount += parseInt(value.gross_amount);
                      thiss.total_rent_annual += parseInt(value.rent_annual);
                      thiss.realestates[index].lvr = ((parseInt(thiss.split_current_balance)/parseInt(value.asset_value))*100).toFixed(2);
                      thiss.annual_repayments_limit1 = (parseInt(thiss.split_current_balance)*(parseFloat(thiss.split_interest_rate)/100)).toFixed(2);
                      thiss.annual_repayments_limit2 = (parseInt(thiss.split_current_balance)*12).toFixed(2);
                      if(parseInt(thiss.annual_repayments_limit1) > parseInt(thiss.annual_repayments_limit2)){
                        thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit1);
                        thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit1);
                      }else{
                        thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit2);
                        thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit2);
                      }
                      thiss.total_lvr = ((thiss.total_current_balance/thiss.total_asset_value)*100).toFixed(2);
                    }
                    thiss.showHideLeaderCreditorRealestate.push(showHideLeaderCreditorRealestate);
                    thiss.showHideLeaderMortgageLimitRealestate.push(showHideLeaderMortgageLimitRealestate);
                    thiss.showHideLeaderCurrentBalanceRealestate.push(showHideLeaderCurrentBalanceRealestate);
                    thiss.showHideLeaderIntrestRateRealestate.push(showHideLeaderIntrestRateRealestate);
                    thiss.showHideLeaderInterestRateTermRealestate.push(showHideLeaderInterestRateTermRealestate);
                    thiss.showHideLeaderLoanTypeRealestate.push(showHideLeaderLoanTypeRealestate);
                    thiss.showHideLeaderRepaymentsRealestate.push(showHideLeaderRepaymentsRealestate);
                  });
                }
              });

              thiss.get_tentativeRealEstates(sdf_data.id).subscribe((get_realEstates)=>{
                if(get_realEstates.length > 0){
                  thiss.tentativerealestates = [];
                  thiss.showHideTentativetable = [];
                  let group_id = parseInt('0');

                  thiss.showHideLeaderAddressTentaRealestate = [];
                  thiss.showHideLeaderAssetValueTentaRealestate = [];
                  thiss.showHideLeaderOwnershipTitleTentaRealestate = [];
                  thiss.showHideLeaderCreditorTentaRealestate = [];
                  thiss.showHideLeaderMortgageLimitTentaRealestate = [];
                  thiss.showHideLeaderCurrentBalanceTentaRealestate = [];
                  thiss.showHideLeaderIntrestRateTentaRealestate = [];
                  thiss.showHideLeaderInterestRateTermTentaRealestate = [];
                  thiss.showHideLeaderLoanTypeTentaRealestate = [];
                  thiss.showHideLeaderRepaymentsTentaRealestate = [];
                  thiss.showHideLeaderGrossAmountTentaRealestate = [];
              
                  let showHideLeaderAddressTentaRealestate = [];
                  let showHideLeaderAssetValueTentaRealestate = [];
                  let showHideLeaderOwnershipTitleTentaRealestate = [];
                  let showHideLeaderCreditorTentaRealestate = [];
                  let showHideLeaderMortgageLimitTentaRealestate = [];
                  let showHideLeaderCurrentBalanceTentaRealestate = [];
                  let showHideLeaderIntrestRateTentaRealestate = [];
                  let showHideLeaderInterestRateTermTentaRealestate = [];
                  let showHideLeaderLoanTypeTentaRealestate = [];
                  let showHideLeaderRepaymentsTentaRealestate = [];
                  let showHideLeaderGrossAmountTentaRealestate = [];

                  get_realEstates.forEach(function (value, key) {
                    
                    if(thiss.showCurrentTentativetable && thiss.showCurrentTentativetableIndex == key){
                      thiss.showHideTentativetable.push(true);
                    }else{
                      thiss.showHideTentativetable.push(false);
                    }

                    
                    
                    if(value.group_id != group_id){
                      
                      showHideLeaderAddressTentaRealestate = [];
                      showHideLeaderAssetValueTentaRealestate = [];
                      showHideLeaderOwnershipTitleTentaRealestate = [];
                      showHideLeaderCreditorTentaRealestate = [];
                      showHideLeaderMortgageLimitTentaRealestate = [];
                      showHideLeaderCurrentBalanceTentaRealestate = [];
                      showHideLeaderIntrestRateTentaRealestate = [];
                      showHideLeaderInterestRateTermTentaRealestate = [];
                      showHideLeaderLoanTypeTentaRealestate = [];
                      showHideLeaderRepaymentsTentaRealestate = [];
                      showHideLeaderGrossAmountTentaRealestate = [];  

                      let totalECB = parseInt('0');
                      let totalCB = parseInt('0');
                      let totalML = parseInt('0');
                      let totalAA = parseInt('0');
                      let totalMR = parseInt('0');
                      let totalARL = parseInt('0');
                      let totalRIW = parseInt('0');
                      let totalRA = parseInt('0');
                      let totalLVR = '';

                      var groupData = thiss.getDimensionsByFilter(value.group_id, get_realEstates);

                      groupData.forEach(function (value1, key1) {
                        
                        let showHideLeaderCreditorTentaRealestateSplit = [];
                        let showHideLeaderMortgageLimitTentaRealestateSplit = [];
                        let showHideLeaderCurrentBalanceTentaRealestateSplit = [];
                        let showHideLeaderIntrestRateTentaRealestateSplit = [];
                        let showHideLeaderInterestRateTermTentaRealestateSplit = [];
                        let showHideLeaderLoanTypeTentaRealestateSplit = [];
                        let showHideLeaderRepaymentsTentaRealestateSplit = [];
                        
                        let split_tentative_creditor = '';
                        let split_tentative_interest_rate_term = '';
                        let split_tentative_loan_type = '';
                        let split_tentative_mortgage_limit = parseInt('0');
                        let split_tentative_current_balance = parseInt('0');
                        let split_tentative_available_redraw = parseInt('0');
                        let split_tentative_repayments = parseInt('0');
                        let split_tentative_interest_rate = parseInt('0');
                        let annual_repayments_limit1 = parseInt('0');
                        if(value1.split.length > 0){
                          value1.split.forEach(function (value2, key2) {

                            showHideLeaderCreditorTentaRealestateSplit.push(0);
                            showHideLeaderMortgageLimitTentaRealestateSplit.push(0);
                            showHideLeaderCurrentBalanceTentaRealestateSplit.push(0);
                            showHideLeaderIntrestRateTentaRealestateSplit.push(0);
                            showHideLeaderInterestRateTermTentaRealestateSplit.push(0);
                            showHideLeaderLoanTypeTentaRealestateSplit.push(0);
                            showHideLeaderRepaymentsTentaRealestateSplit.push(0);

                            split_tentative_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                            split_tentative_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                            split_tentative_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                            split_tentative_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
                            split_tentative_interest_rate += parseFloat(value2.interest_rate);
                            split_tentative_creditor = value2.creditor;
                            split_tentative_loan_type = value2.loan_type;
                            split_tentative_interest_rate_term = value2.interest_rate_term;

                            let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                            let IR = parseFloat(value2.interest_rate);

                            annual_repayments_limit1 += ((CB)*(IR/100));

                            groupData[key1].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                            groupData[key1].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                            groupData[key1].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                            groupData[key1].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
                          });
                        }

                        groupData[key1].creditor = split_tentative_creditor;
                        groupData[key1].interest_rate_term = split_tentative_interest_rate_term;
                        groupData[key1].loan_type = split_tentative_loan_type;
                        groupData[key1].mortgage_limit = split_tentative_mortgage_limit;
                        groupData[key1].current_balance = split_tentative_current_balance;
                        groupData[key1].available_redraw = split_tentative_available_redraw;
                        groupData[key1].repayments = split_tentative_repayments;
                        groupData[key1].interest_rate = split_tentative_interest_rate;
                        //groupData[key1].available_redraw = split_tentative_mortgage_limit - split_tentative_current_balance;
                        groupData[key1].lvr = ((split_tentative_current_balance/parseInt(value1.asset_value))*100).toFixed(2);


                        totalECB += parseInt(value1.asset_value);
                        totalCB += split_tentative_current_balance;
                        totalML += split_tentative_mortgage_limit;
                        totalAA += split_tentative_available_redraw;
                        totalMR += split_tentative_repayments;
                        totalRIW += parseInt(value1.gross_amount);
                        totalRA += parseInt(value1.rent_annual);
                        totalLVR = ((totalCB/totalECB)*100).toFixed(2);

                        let annual_repayments_limit2 = (totalMR*12).toFixed(2);
                        if(annual_repayments_limit1 > parseInt(annual_repayments_limit2)){
                          groupData[key1].annual_repayments_limit = annual_repayments_limit1;
                          totalARL += annual_repayments_limit1;
                        }else{
                          groupData[key1].annual_repayments_limit = parseInt(annual_repayments_limit2);
                          totalARL += parseInt(annual_repayments_limit2);
                        }

                        showHideLeaderAddressTentaRealestate.push(0);
                        showHideLeaderAssetValueTentaRealestate.push(0);
                        showHideLeaderOwnershipTitleTentaRealestate.push(0);
                        showHideLeaderGrossAmountTentaRealestate.push(0);
                        showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestateSplit);
                        showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestateSplit);
                        showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestateSplit);
                        showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestateSplit);
                        showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestateSplit);
                        showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestateSplit);
                        showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestateSplit);                    


                      });
                      let splitData = [];
                      splitData.push({});
                      groupData.push({'current_balance' : totalCB, 'mortgage_limit' : totalML, 'asset_value' : totalECB, 'available_redraw' : totalAA, 'repayments' : totalMR, 'gross_amount' : totalRIW, 'rent_annual' : totalRA, 'lvr' : totalLVR, 'annual_repayments_limit' : totalARL.toFixed(2), 'split' : splitData});

                      thiss.tentativerealestates.push(groupData);

                      thiss.showHideLeaderAddressTentaRealestate.push(showHideLeaderAddressTentaRealestate);
                      thiss.showHideLeaderAssetValueTentaRealestate.push(showHideLeaderAssetValueTentaRealestate);
                      thiss.showHideLeaderOwnershipTitleTentaRealestate.push(showHideLeaderOwnershipTitleTentaRealestate);
                      thiss.showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestate);
                      thiss.showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestate);
                      thiss.showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestate);
                      thiss.showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestate);
                      thiss.showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestate);
                      thiss.showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestate);
                      thiss.showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestate);
                      thiss.showHideLeaderGrossAmountTentaRealestate.push(showHideLeaderGrossAmountTentaRealestate);
                    }
                    group_id = value.group_id;
                  });
                }
              });

              thiss.approval_log = thiss.contact_uid;
              if(thiss.user_data.contact_type == "Secondary Contact"){
                thiss.priSec_uid = thiss.user_data.main_contact_uid;
                thiss.approval_log = thiss.user_data.main_contact_uid;
              }else{
                thiss.priSec_uid = thiss.user_data.secondary_contact_uid;
              }
              if(thiss.approval_log != ''){
                thiss.getapproval_log(thiss.approval_log).subscribe((approval_log)=>{
                  if(approval_log.length > 0){
                    thiss.approval_log_data = approval_log;
                  }else{
                    thiss.approval_log_data = 0;
                  }
                });
                thiss.get_user_history().subscribe((user_history_data)=>{
                  if(user_history_data.length > 0){
                    for(let i = 0; i < user_history_data.length; i++) {
                      if(user_history_data[i].uid == "" || user_history_data[i].uid == null || user_history_data[i].uid == undefined){}else{
                        var docRef1 = firebase.firestore().collection("users").doc(user_history_data[i].uid);
                        docRef1.get().then(function(doc) {
                          if (doc.exists) {
                            user_history_data[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
                          }
                        }).catch(function(error) {
                          
                        });
                      }
                      if(user_history_data[i].contact_uid == "" || user_history_data[i].contact_uid == null || user_history_data[i].contact_uid == undefined){}else{
                        firebase.firestore().collection("users_data").where('SDF_form_document_id','==',thiss.SDF_form_document_id).where('uid','==',user_history_data[i].contact_uid).get()
                        .then(function(querySnapshot2) {
                          querySnapshot2.forEach(function(userDoc) {
                              user_history_data[i].username = userDoc.data().firstname+' '+userDoc.data().lastname;
                          })
                        }).catch(function(error) {
                          
                        });
                      }
                    }
                    thiss.user_history = user_history_data;
                  }else{
                    thiss.user_history = 0;
                  }
                });
                
              }
              let reference_broker = thiss.user_data.reference_broker;
              if(reference_broker == "" || reference_broker == null || reference_broker == undefined){}else{
                thiss.getBrokerDetails(reference_broker).subscribe((brokerDetails)=>{
                  if(brokerDetails.length > 0){
                    thiss.assigned_broker_name = brokerDetails[0].firstname +' '+ brokerDetails[0].lastname;
                  }else{
                    thiss.assigned_broker_name = 'Broker not assigned';
                  }
                });
              }

              if(thiss.user_data.how_many_children > 0){}else{
                thiss.user_data.how_many_children = 0;
              }
              if(doc.data().contact_type == "Primary Contact"){
                thiss.primary_secondary_found = 'Primary';
                thiss.primary_secondary_contact_uid = doc.data().secondary_contact_uid;
                thiss.primary_tag = thiss.user_data.firstname+' '+thiss.user_data.lastname;
              }else{
                thiss.primary_secondary_found = 'Secondary';
                thiss.primary_secondary_contact_uid = doc.data().main_contact_uid;
                thiss.primary_tag = thiss.user_data.firstname+' '+thiss.user_data.lastname;
              }
              if(doc.data().accessPermission == 1){
                thiss.accessPermissioncheckstatus = 'ios-unlock-outline';
                thiss.accessPermissionname = 'Disallow Customer Access';
              }else{
                thiss.accessPermissioncheckstatus = 'ios-lock-outline';
                thiss.accessPermissionname = 'Allow Customer Access';
              }
            }
          });
        }

      }).catch(function(error) {
        console.log("Error getting document:", error);
      });

      thiss.getAllTentativeRealEstates().subscribe((tdata)=>{
        if(tdata.length > 0){
          thiss.tentativerealestates = [];
          thiss.showHideTentativetable = [];
          let group_id = parseInt('0');

          thiss.showHideLeaderAddressTentaRealestate = [];
          thiss.showHideLeaderAssetValueTentaRealestate = [];
          thiss.showHideLeaderOwnershipTitleTentaRealestate = [];
          thiss.showHideLeaderCreditorTentaRealestate = [];
          thiss.showHideLeaderMortgageLimitTentaRealestate = [];
          thiss.showHideLeaderCurrentBalanceTentaRealestate = [];
          thiss.showHideLeaderIntrestRateTentaRealestate = [];
          thiss.showHideLeaderInterestRateTermTentaRealestate = [];
          thiss.showHideLeaderLoanTypeTentaRealestate = [];
          thiss.showHideLeaderRepaymentsTentaRealestate = [];
          thiss.showHideLeaderGrossAmountTentaRealestate = [];
      
          let showHideLeaderAddressTentaRealestate = [];
          let showHideLeaderAssetValueTentaRealestate = [];
          let showHideLeaderOwnershipTitleTentaRealestate = [];
          let showHideLeaderCreditorTentaRealestate = [];
          let showHideLeaderMortgageLimitTentaRealestate = [];
          let showHideLeaderCurrentBalanceTentaRealestate = [];
          let showHideLeaderIntrestRateTentaRealestate = [];
          let showHideLeaderInterestRateTermTentaRealestate = [];
          let showHideLeaderLoanTypeTentaRealestate = [];
          let showHideLeaderRepaymentsTentaRealestate = [];
          let showHideLeaderGrossAmountTentaRealestate = [];

          tdata.forEach(function (value, key) {
            
            if(thiss.showCurrentTentativetable && thiss.showCurrentTentativetableIndex == key){
              thiss.showHideTentativetable.push(true);
            }else{
              thiss.showHideTentativetable.push(false);
            }

            
            
            if(value.group_id != group_id){
              
              showHideLeaderAddressTentaRealestate = [];
              showHideLeaderAssetValueTentaRealestate = [];
              showHideLeaderOwnershipTitleTentaRealestate = [];
              showHideLeaderCreditorTentaRealestate = [];
              showHideLeaderMortgageLimitTentaRealestate = [];
              showHideLeaderCurrentBalanceTentaRealestate = [];
              showHideLeaderIntrestRateTentaRealestate = [];
              showHideLeaderInterestRateTermTentaRealestate = [];
              showHideLeaderLoanTypeTentaRealestate = [];
              showHideLeaderRepaymentsTentaRealestate = [];
              showHideLeaderGrossAmountTentaRealestate = [];  

              let totalECB = parseInt('0');
              let totalCB = parseInt('0');
              let totalML = parseInt('0');
              let totalMR = parseInt('0');
              let totalARL = parseInt('0');
              let totalRIW = parseInt('0');
              let totalRA = parseInt('0');
              let totalLVR = '';

              var groupData = thiss.getDimensionsByFilter(value.group_id, tdata);

              groupData.forEach(function (value1, key1) {
                
                let showHideLeaderCreditorTentaRealestateSplit = [];
                let showHideLeaderMortgageLimitTentaRealestateSplit = [];
                let showHideLeaderCurrentBalanceTentaRealestateSplit = [];
                let showHideLeaderIntrestRateTentaRealestateSplit = [];
                let showHideLeaderInterestRateTermTentaRealestateSplit = [];
                let showHideLeaderLoanTypeTentaRealestateSplit = [];
                let showHideLeaderRepaymentsTentaRealestateSplit = [];
                
                let split_tentative_creditor = '';
                let split_tentative_interest_rate_term = '';
                let split_tentative_loan_type = '';
                let split_tentative_mortgage_limit = parseInt('0');
                let split_tentative_current_balance = parseInt('0');
                let split_tentative_repayments = parseInt('0');
                let split_tentative_interest_rate = parseInt('0');
                let annual_repayments_limit1 = parseInt('0');
                if(value1.split.length > 0){
                  value1.split.forEach(function (value2, key2) {

                    showHideLeaderCreditorTentaRealestateSplit.push(0);
                    showHideLeaderMortgageLimitTentaRealestateSplit.push(0);
                    showHideLeaderCurrentBalanceTentaRealestateSplit.push(0);
                    showHideLeaderIntrestRateTentaRealestateSplit.push(0);
                    showHideLeaderInterestRateTermTentaRealestateSplit.push(0);
                    showHideLeaderLoanTypeTentaRealestateSplit.push(0);
                    showHideLeaderRepaymentsTentaRealestateSplit.push(0);

                    split_tentative_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    split_tentative_mortgage_limit += parseInt(value2.mortgage_limit.split("$").join("").split(",").join(""));
                    split_tentative_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
                    split_tentative_interest_rate += parseFloat(value2.interest_rate);
                    split_tentative_creditor = value2.creditor;
                    split_tentative_loan_type = value2.loan_type;
                    split_tentative_interest_rate_term = value2.interest_rate_term;

                    let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    let IR = parseFloat(value2.interest_rate);

                    annual_repayments_limit1 += ((CB)*(IR/100));

                    groupData[key1].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    groupData[key1].split[key2].mortgage_limit = parseInt(value2.mortgage_limit.split("$").join("").split(",").join(""));
                    groupData[key1].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
                  });
                }

                groupData[key1].creditor = split_tentative_creditor;
                groupData[key1].interest_rate_term = split_tentative_interest_rate_term;
                groupData[key1].loan_type = split_tentative_loan_type;
                groupData[key1].mortgage_limit = split_tentative_mortgage_limit;
                groupData[key1].current_balance = split_tentative_current_balance;
                groupData[key1].repayments = split_tentative_repayments;
                groupData[key1].interest_rate = split_tentative_interest_rate;
                groupData[key1].available_redraw = split_tentative_mortgage_limit - split_tentative_current_balance;
                groupData[key1].lvr = ((split_tentative_current_balance/parseInt(value1.asset_value))*100).toFixed(2);


                totalECB += parseInt(value1.asset_value);
                totalCB += split_tentative_current_balance;
                totalML += split_tentative_mortgage_limit;
                totalMR += split_tentative_repayments;
                totalRIW += parseInt(value1.gross_amount);
                totalRA += parseInt(value1.rent_annual);
                totalLVR = ((totalCB/totalECB)*100).toFixed(2);

                let annual_repayments_limit2 = (totalMR*12).toFixed(2);
                if(annual_repayments_limit1 > parseInt(annual_repayments_limit2)){
                  groupData[key1].annual_repayments_limit = annual_repayments_limit1;
                  totalARL += annual_repayments_limit1;
                }else{
                  groupData[key1].annual_repayments_limit = parseInt(annual_repayments_limit2);
                  totalARL += parseInt(annual_repayments_limit2);
                }

                showHideLeaderAddressTentaRealestate.push(0);
                showHideLeaderAssetValueTentaRealestate.push(0);
                showHideLeaderOwnershipTitleTentaRealestate.push(0);
                showHideLeaderGrossAmountTentaRealestate.push(0);
                showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestateSplit);
                showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestateSplit);
                showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestateSplit);
                showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestateSplit);
                showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestateSplit);
                showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestateSplit);
                showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestateSplit);                    


              });
              let splitData = [];
              splitData.push({});
              groupData.push({'current_balance' : totalCB, 'mortgage_limit' : totalML, 'asset_value' : totalECB, 'available_redraw' : (totalML - totalCB), 'repayments' : totalMR, 'gross_amount' : totalRIW, 'rent_annual' : totalRA, 'lvr' : totalLVR, 'annual_repayments_limit' : totalARL.toFixed(2), 'split' : splitData});

              thiss.tentativerealestates.push(groupData);

              thiss.showHideLeaderAddressTentaRealestate.push(showHideLeaderAddressTentaRealestate);
              thiss.showHideLeaderAssetValueTentaRealestate.push(showHideLeaderAssetValueTentaRealestate);
              thiss.showHideLeaderOwnershipTitleTentaRealestate.push(showHideLeaderOwnershipTitleTentaRealestate);
              thiss.showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestate);
              thiss.showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestate);
              thiss.showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestate);
              thiss.showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestate);
              thiss.showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestate);
              thiss.showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestate);
              thiss.showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestate);
              thiss.showHideLeaderGrossAmountTentaRealestate.push(showHideLeaderGrossAmountTentaRealestate);
            }
            group_id = value.group_id;
          });
        }
      });
    }

    this.showDetails = true;
    this.icon = 'ios-remove-circle-outline';

    this.updateEmailPhoneForm = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10),Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    });

    this.updateEmailPhoneFormSec = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(10),Validators.maxLength(10), Validators.required])],
      edit_con_uid: ['']
    })

  }

  updateEmailPhone(contact_id, form, userType){
    let userForm = form;
    if(!userForm.valid){

      userForm.get('email').markAsDirty();
      userForm.get('email').markAsTouched();

      userForm.get('mobile_phone').markAsDirty();
      userForm.get('mobile_phone').markAsTouched();

    }else{

      this.loadingProvider.startLoading();
      let email = userForm.value.email;
      let mobile_phone = userForm.value.mobile_phone;
      //let contact_id = this.updateEmailPhoneForm.value.edit_con_uid;
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        "email": email,
        "phoneNumber": "+6"+mobile_phone,
        "mobile_phone": mobile_phone,
        "contact_id" : contact_id
      }
      var url = this.EnvDataService.EnvData.sendbox_api+"/updateViewPageContactDetails";
      this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if(data['_body'] == 'The email address is already in use by another account.'){
          this.presentToast(data['_body']);
        }else if(data['_body'] == 'The user with the provided phone number already exists.'){
          this.presentToast(data['_body']);
        }else if(data['_body'] == 'TOO_LONG'){
          this.presentToast('Invalid Phone Number.');
        }else if(data['_body'] == 'TOO_SHORT'){
          this.presentToast('Invalid Phone Number.');
        }else if(data['_body'] == 'Invalid format.'){
          this.presentToast('Invalid Phone Number.');
        }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
          this.presentToast('Invalid Phone Number.');
        }else{
          this.editEmailOption = 0;
          this.editPhoneOption = 0;
          this.editEmailOptionSecond = 0;
          this.editPhoneOptionSecond = 0;
          if(email != ""){
            if(userType == 'primary'){
              this.user_data.email = email;
            }else if(userType == 'secondary'){
              this.primSecondContact.email = email;
            }
          }
          if(mobile_phone != ""){
            if(userType == 'primary'){
              this.user_data.mobile_phone = mobile_phone;
            }else if(userType == 'secondary'){
              this.primSecondContact.mobile_phone = mobile_phone;
            }
          }
        }
        this.loadingProvider.stopLoading();
      }, error => {
        this.loadingProvider.stopLoading();
        this.presentToast(error.message);
      });
    }
  }

  getBrokerDetails (reference_broker){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',reference_broker ).where('deleted','<',1 )).valueChanges ();
  }

  getapproval_log (contact_uid){
    return this.db.collection<any>( "approval_log" , ref => ref.where('created_date','>',0 ).where('uid','==',contact_uid ).orderBy('created_date', 'asc').limit(50)).valueChanges ();
  }

  get_user_history (){
    return this.db.collection<any>( "user_history" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',this.SDF_form_document_id ).orderBy('created_date', 'desc')).valueChanges ();
  }

  getPrimarySecondaryContact (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.primary_secondary_contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getaccessGrantedFromUserstatus (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getPrimarySecondaryemployment (){
    return this.db.collection<any>( "employment" , ref => ref.where('uid','==',this.primary_secondary_contact_uid )).valueChanges ();
  }

  getAllIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllSecIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.primary_secondary_contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllSecAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.primary_secondary_contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllSecLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.primary_secondary_contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstates (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstatesS (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('secondary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllTentativeRealEstates (){
    if(this.document_id != undefined){
      return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('primary_uid','==',this.contact_uid ).where('deleted','<',1 ).where('document_id','==',this.document_id )).valueChanges ();
    }else{
      return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('primary_uid','==',this.contact_uid ).where('deleted','==',0 ).orderBy('group_id','asc')).valueChanges ();
    }
  }

  getAllTentativeRealEstatesS (){
    if(this.document_id != undefined){
      return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('secondary_uid','==',this.contact_uid ).where('deleted','<',1 ).where('document_id','==',this.document_id )).valueChanges ();
    }else{
      return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('secondary_uid','==',this.contact_uid ).where('deleted','==',0 ).orderBy('group_id','asc')).valueChanges ();
    }
  }

  get_user_data (contact_uid, SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid).where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','<',1 )).valueChanges ();
  }

  get_second_user_data (SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('created_date','>',0 ).where('contact_type','==','Secondary Contact').where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_SDF_form (SDF_form_document_id){
    return this.db.collection<any>( "SDF_form" , ref => ref.where('id','==',SDF_form_document_id)).valueChanges ();
  }

  get_incomes (SDF_form_document_id){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_assets (SDF_form_document_id){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_liabilities (SDF_form_document_id){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_realEstates (SDF_form_document_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_tentativeRealEstates (SDF_form_document_id){
    return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_owner (SDF_form_document_id, uid){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id).where('uid','==',uid).where('deleted','<',1)).valueChanges ();
  }

  ionViewDidLoad() {

  }


  viewContactPDF(event, contact_uid, t_document_id, SDF_form_document_id){
    this.navCtrl.push(ViewContactPdfPage,{
      contact_uid:contact_uid,
      t_document_id: t_document_id,
      SDF_form_document_id: SDF_form_document_id
      });
  }

  viewSingleAssets(i, type){
    if(type == 'asset'){
      if(this.assets[i].show == 1){
        this.assets[i].show = 0;
      }else{
        this.assets[i].show = 1;
      }
    }else if(type == 'liability'){
      if(this.liabilities[i].show == 1){
        this.liabilities[i].show = 0;
      }else{
        this.liabilities[i].show = 1;
      }
    }else if(type == 'income'){
      if(this.incomes[i].show == 1){
        this.incomes[i].show = 0;
      }else{
        this.incomes[i].show = 1;
      }
    }
  }

  editTentativeRealEstateByGroup(event, contact_uid, group_id, SDF_form_document_id){
    window.localStorage.removeItem("generate_new_tentative");
    let primary_id = '';
    let secondary_id = '';
    if(this.primary_secondary_found == "Primary"){
      secondary_id = this.primary_secondary_contact_uid;
      primary_id = this.contact_uid;
    }else{
      primary_id = this.primary_secondary_contact_uid;
      secondary_id = this.contact_uid;
    }
    if(secondary_id == undefined){
      secondary_id = '';
    }
    window.localStorage.setItem("contact_uid", primary_id);
    window.localStorage.setItem("contact_second_uid", secondary_id);
    this.navCtrl.push(TentativeRealEstateAssetPage,{
      edit_contact_uid:primary_id,
      second_contact_id : secondary_id,
      group_id: group_id,
      SDF_form_document_id: SDF_form_document_id
      });
  }

  sendEmailtoCustomerWithTentative(event, contact_uid, t_document_id){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid' : contact_uid,
      'document_id' : t_document_id
    }
    var url = this.EnvDataService.EnvData.sendbox_api+"/sendEmailtoCustomerWithTentative";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      this.loadingProvider.stopLoading();
      if(data['_body'] == 'success'){
        this.presentToast('Email sent successfully.');
      }else{
        this.presentToast('Something went wrong please try again later.');
      }
    }, error => {
      this.loadingProvider.stopLoading();
    });
  }

  permissionToUser(event, contact_uid, allowCustoeditPermission, allowCustoViewOnlyPermission, SDF_form_document_id){

    let editMenu = this.popoverCtrl.create(AllowCustomerPermissionPage, {contact_uid: contact_uid, allowCustoeditPermission: allowCustoeditPermission, allowCustoViewOnlyPermission: allowCustoViewOnlyPermission, SDF_form_document_id: SDF_form_document_id}, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event
    });
  }


  accessToUser(event, contact_uid, accessPermission, nextAccess){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    this.accessPermissionStatus = 0;
    if(accessPermission == 0){
      this.accessPermissionStatus = 1;
    }
    let postData = {
      'contact_uid' : contact_uid,
      'accessPermission': this.accessPermissionStatus
    }
    var url = this.EnvDataService.EnvData.sendbox_api+"/sendEmailtoCustomer";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      if(data['_body'] == 'success'){
        if(this.accessPermissionStatus == 1){
          if(nextAccess == "yes"){
            this.accessPermissioncheckstatusPS = 'ios-lock-outline';
            this.accessPermissionnamePS = 'Allow Customer Access';
          }else{
            this.accessPermissioncheckstatus = 'ios-unlock-outline';
            this.accessPermissionname = 'Disallow Customer Access';
          }
          this.presentToast('Allow access to customer.');
        }else{
          if(nextAccess == "yes"){
            this.accessPermissioncheckstatusPS = 'ios-lock-outline';
            this.accessPermissionnamePS = 'Allow Customer Access';
          }else{
            this.accessPermissioncheckstatus = 'ios-lock-outline';
            this.accessPermissionname = 'Allow Customer Access';
          }
          this.presentToast('Disallow access to customer.');
        }
      }else{
        this.presentToast('Something went wrong please try again later.');
      }
      this.loadingProvider.stopLoading();
    }, error => {
      this.loadingProvider.stopLoading();
    });
  }


  accessGrantedFromUserBySubmit(event, contact_uid, broker_uid, email, name, main_contact_uid, secondary_contact_uid){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid' : contact_uid,
      'broker_uid' : broker_uid,
      'email' : email,
      'name' : name,
      "created_date" : new Date().getTime(),
      "contact_type" : this.user_data.contact_type,
      "user_history_created_by" : contact_uid,
      "SDF_form_document_id": this.SDF_form_document_id
    }
    var url = this.EnvDataService.EnvData.sendbox_api+"/accessGrantedFromUser";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      if(data['_body'] == 'error'){
        this.presentToast('Something went wrong please try again later.');
      }else{
        this.presentToast('Approved Successfully.');
        this.accessGrantedFromUserstatus = 1;
        this.user_data.allowCustoeditPermission = 0;
        this.user_data.allowCustoViewOnlyPermission = 1;
        postData['ip_address'] = data['_body'];
        postData['status'] = 4;
        this.user_history_data(postData)
      }
      this.loadingProvider.stopLoading();
    }, error => {
      this.presentToast(error.message);
      this.loadingProvider.stopLoading();
    });
  }

  user_history_data(postData){
    const user_history = this.db.collection('/user_history');
    user_history.doc(postData.contact_uid + '_'+ postData.created_date).set({
        created_date : postData.created_date,
        contact_uid : postData.contact_uid,
        document_id: postData.contact_uid+'_'+postData.created_date,
        ip_address: postData.ip_address,
        uid: postData.user_history_created_by,
        contact_type: postData.contact_type,
        name: postData.name,
        status: postData.status,
        deleted : 0
    }).then(function() {
        
    }).catch(function(error) {
        
    });
  }

  accessGrantedFromUser(event, contact_uid, broker_uid, email, name){
    this.loadingProvider.startLoading();
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      'contact_uid' : contact_uid,
      'broker_uid' : broker_uid,
      'email' : email,
      'name' : name
    }
    var url = this.EnvDataService.EnvData.sendbox_api+"/accessGrantedFromUser";
    this.http.post(url, postData, requestOptions)
    .subscribe(data => {
      if(data['_body'] == 'success'){
        this.presentToast('Approved Successfully.');
        this.accessGrantedFromUserstatus = 1;
      }else{
        this.presentToast('Something went wrong please try again later.');
      }
      this.loadingProvider.stopLoading();
    }, error => {
      this.presentToast(error.message);
      this.loadingProvider.stopLoading();
    });
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      console.log(e)
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  popupAction(event: any, contact_uid: any, SDF_form_document_id: any, contact_type: any){
    let editMenu = this.popoverCtrl.create(EditPopoverPage, {contact_uid: contact_uid, view_contact: 'yes', SDF_form_document_id: SDF_form_document_id, contact_type: contact_type}, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event // <-- the fix
    });

    editMenu.onDidDismiss(data =>{
      if(data == "" || data == null || data == undefined){}else{
        if(data.type == 'viewcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ViewContactPage,{
            contact_uid:contact_uid, 
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'editcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(StepformPage,{
            edit_contact_uid:contact_uid, 
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'addsecondary'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("creating_second", 'yes');
          this.navCtrl.push(StepformPage);
        }else if(data.type == 'realestate'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
          this.navCtrl.push(RealEstatePage,{
            edit_contact_uid:data.contact_id_add_real_estate,
            second_contact_id : data.second_contact_id,
            SDF_form_document_id : data.SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        }else if(data.type == 'tentativerealestate'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          window.localStorage.setItem("SDF_form_document_id", data.SDF_form_document_id);
          this.navCtrl.push(TentativeRealEstateAssetPage,{
            edit_contact_uid:data.contact_id_add_real_estate,
            second_contact_id : data.second_contact_id,
            SDF_form_document_id : data.SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        }else if(data.type == 'changelog'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ChangeLogProfilePage,{
            contact_uid:contact_uid
          });
        }else if(data.type == 'syncMercury'){
          this.syncInMercury('', data.userData, '', data.userData.accessGrantedFromUser);
        }
      }
    });
  }

  syncInMercury(event, contact_data, reference_broker = '', accessGrantedFromUser = 0){
    let popUpTitle = 'Confirm Sync contact';
    let popUpDesc = 'Are you sure you want to sync contact with mercury?';
    let popUpCheckbox = [];
    if(accessGrantedFromUser != 1){
      popUpCheckbox = [{
        name: "name",
        type: "checkbox",
        label: "The contact details are not approved. Please confirm before continue."
      }];
      //this.presentToastSuccess('Contact not approved by user.');
    }
      
    this.assets_data = '';
    this.liabilities_data = '';
    this.realEstate_data = '';
    let alert = this.alertCtrl.create({
      title: popUpTitle,
      subTitle: popUpDesc,
      //message: popUpDesc,
      inputs: popUpCheckbox,
      cssClass: 'alertDanger',
      buttons: [
        {
            text: 'No',
            handler: () => {
                console.log('Cancel clicked');
            }
        },
        {
          text: 'Yes',
          handler: () => {
            if(accessGrantedFromUser != 1){
              if(alert.data.inputs[0].checked == false){
                alert.setMessage('Please confirm before continue.');
                return false;  
              }
            }

            if(contact_data){
              this.loadingProvider.startLoading();

              this.getBrokerCredentail(contact_data.reference_broker).subscribe((broker_data)=>{
                if(broker_data.length > 0){
                  this.getEmployments(contact_data.uid).subscribe((employment_data)=>{
                    this.getAllAssetss(contact_data.uid).subscribe((assets_data)=>{
                      this.assets_data = assets_data;
                    });
                    this.getAllLiabilitiess(contact_data.uid).subscribe((liabilities_data)=>{
                      this.liabilities_data = liabilities_data;
                    });

                    this.getAllrealEstate(contact_data.uid).subscribe((realEstate_data)=>{
                      this.realEstate_data = realEstate_data;
                    });

                    if(contact_data.secondary_contact_uid == "" || contact_data.secondary_contact_uid == null || contact_data.secondary_contact_uid == undefined){
                      this.second_contact_data = '';
                      this.second_employment_data = '';
                      this.second_income_data = '';
                      this.second_asset_data = '';
                      this.second_liabilities_data = '';
                    }else{
                      this.getContactDetails(contact_data.secondary_contact_uid).subscribe((second_contact_data)=>{
                        this.second_contact_data = second_contact_data;
                      });
                      this.getEmployments(contact_data.secondary_contact_uid).subscribe((second_employment_data)=>{
                        this.second_employment_data = second_employment_data;
                      });
                      this.getAllIncomess(contact_data.secondary_contact_uid).subscribe((second_income_data)=>{
                        this.second_income_data = second_income_data;
                      });
                      this.getAllAssetss(contact_data.secondary_contact_uid).subscribe((second_asset_data)=>{
                        this.second_asset_data = second_asset_data;
                      });
                      this.getAllLiabilitiess(contact_data.secondary_contact_uid).subscribe((second_liabilities_data)=>{
                        this.second_liabilities_data = second_liabilities_data;
                      });
                    }

                    this.getAllIncomess(contact_data.uid).subscribe((income_data)=>{
                      var headers = new Headers();
                      headers.append("Accept", 'application/json');
                      headers.append('Content-Type', 'application/json' );
                      const requestOptions = new RequestOptions({ headers: headers });
                      let postData = {
                        'contact_data' : contact_data,
                        'employment_data' : employment_data[0],
                        'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                        'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                        'income_data' : income_data
                      }
                      var url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncContact";
                      this.http.post(url, postData, requestOptions)
                      .subscribe(getData => {
                        let responseData = JSON.parse(getData['_body']);
                        if(responseData.name != undefined){
                          this.loadingProvider.stopLoading();
                          this.presentToastSuccess('Something went wrong please try again later.');      
                        }else{
                          if(this.second_contact_data.length > 0){
                            let secondPostData = {
                              'contact_data' : this.second_contact_data[0],
                              'employment_data' : this.second_employment_data[0],
                              'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                              'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                              'income_data' : this.second_income_data
                            }
                            let url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncContact";
                            this.http.post(url, secondPostData, requestOptions)
                            .subscribe(getSecondData => {
                              let responseSecondData = JSON.parse(getSecondData['_body']);
                              if(responseSecondData.name != undefined){
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Something went wrong please try again later.');      
                              }else{
                                let oppurtunityData = {
                                  'contact_data' : contact_data,
                                  'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                                  'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                                  'uniqueId' : responseData.uniqueId,
                                  'assets_data' : this.assets_data,
                                  'liabilities_data' : this.liabilities_data,
                                  'second_uniqueId' : responseSecondData.uniqueId,
                                  'second_contact_data' : this.second_contact_data[0],
                                  'second_assets_data' : this.second_asset_data,
                                  'second_liabilities_data' : this.second_liabilities_data,
                                  'realEstate_data' : this.realEstate_data
                                }
                                let url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncCreateOportunity";
                                this.http.post(url, oppurtunityData, requestOptions)
                                .subscribe(getOData => {
                                  let responseOData = JSON.parse(getOData['_body']);
                                  if(responseOData.name != undefined){
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Oppurtunity not created.'); 
                                  }else{
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Contact sync successfully.');
                                  }
                                }, error => {
                                  this.loadingProvider.stopLoading();
                                  this.presentToast(error);      
                                }); 
                              }
                            });

                          }else{
                            let oppurtunityData = {
                              'contact_data' : contact_data,
                              'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                              'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                              'uniqueId' : responseData.uniqueId,
                              'assets_data' : this.assets_data,
                              'liabilities_data' : this.liabilities_data,
                              'second_uniqueId' : undefined,
                              'second_contact_data' : undefined,
                              'realEstate_data' : this.realEstate_data
                            }
                            let url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncCreateOportunity";
                            this.http.post(url, oppurtunityData, requestOptions)
                            .subscribe(getOData => {
                              let responseOData = JSON.parse(getOData['_body']);
                              if(responseOData.name != undefined){
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Oppurtunity not created.');      
                              }else{
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Contact sync successfully.'); 
                              }
                            }, error => {
                              this.loadingProvider.stopLoading();
                              this.presentToast(error);      
                            });    
                          }
                        }
                      }, error => {
                        this.loadingProvider.stopLoading();
                        this.presentToast(error);      
                      });
                    });
                  });
                }else{
                  this.loadingProvider.stopLoading();
                  this.presentToastSuccess('Broker not assigned.'); 
                }
              });
            }
          }
        }
      ]
    });
    alert.present();
    //}
  }


  getContactDetails(contact_uid){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0)).valueChanges();
  }

  getBrokerCredentail(contact_uid){
    return this.db.collection<any>( "brokerCredentials" , ref => ref.where('uid','==',contact_uid )).valueChanges ();
  }

  getEmployments(contact_uid){
    return this.db.collection<any>( "employment" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllIncomess(contact_uid){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllAssetss(contact_uid){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllLiabilitiess(contact_uid){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllrealEstate(contact_uid){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  editContact(event, contact_uid, SDF_form_document_id){
    this.navCtrl.push(StepformPage,{
      edit_contact_uid:contact_uid,
      SDF_form_document_id: SDF_form_document_id
    });
  }

  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  tentative_real_estate(SDF_form_document_id){
    let primary_id = '';
    let secondary_id = '';
    if(this.primary_secondary_found == "Primary"){
      secondary_id = this.primary_secondary_contact_uid;
      primary_id = this.contact_uid;
    }else{
      primary_id = this.primary_secondary_contact_uid;
      secondary_id = this.contact_uid;
    }
    if(secondary_id == undefined){
      secondary_id = '';
    }
    window.localStorage.setItem("contact_uid", primary_id);
    window.localStorage.setItem("contact_second_uid", secondary_id);
    this.navCtrl.push(TentativeRealEstateAssetPage,{
      edit_contact_uid:primary_id,
      second_contact_id : secondary_id,
      SDF_form_document_id: SDF_form_document_id
    });
    window.localStorage.setItem("generate_new_tentative", '1');
    this.viewCtrl.dismiss();
  }

  changeEvent(event) {
    if (event.value) {
      this.agreed = true;
    }else{
      this.agreed = false;
    }
  }

  ngAfterViewInit(){

  }
  setAsPrimary($event, contact_uid, group_id, SDF_form_document_id){
    let alert = this.alertCtrl.create({
      title: 'are you sure',
      message: 'Are you sure you want to set as primary Real Estate?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(group_id !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'contact_uid' : contact_uid,
                    'group_id' : group_id,
                    'SDF_form_document_id' : SDF_form_document_id
                  }
                  let url = this.EnvDataService.EnvData.sendbox_api+"/setAsPrimaryRealEstate";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == ""){
                      this.presentToast('Set as Primary Real Estate Successfully.');
                      this.accessGrantedFromUserstatus = 1;
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                    }
                    this.loadingProvider.stopLoading();
                  }, error => {
                    this.presentToast(error.message);
                    this.loadingProvider.stopLoading();
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  changeEmailPhone(event, form, userType, type){
    let selectedForm = form;
    if(type == 'email'){
      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      getemail.setValidators([Validators.required, Validators.email, Validators.minLength(10), Validators.required]);
      getmobile_phone.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if(userType == 'primary'){
        this.editEmailOption = 1;
        this.editPhoneOption = 0;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;
      }else if(userType == 'secondary'){
        this.editEmailOptionSecond = 1;
        this.editPhoneOptionSecond = 0;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    }else if(type == 'phone'){
      let getemail = selectedForm.get('email');
      let getmobile_phone = selectedForm.get('mobile_phone');
      getmobile_phone.setValidators([Validators.minLength(10),Validators.maxLength(10), Validators.required]);
      getemail.setValidators(null);
      getemail.updateValueAndValidity();
      getmobile_phone.updateValueAndValidity();
      if(userType == 'primary'){
        this.editEmailOption = 0;
        this.editPhoneOption = 1;
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 0;
      }else if(userType == 'secondary'){
        this.editEmailOptionSecond = 0;
        this.editPhoneOptionSecond = 1;
        this.editEmailOption = 0;
        this.editPhoneOption = 0;
      }
    }
  }

  closeButton(event){
    this.editEmailOption = 0;
    this.editPhoneOption = 0;
    this.editEmailOptionSecond = 0;
    this.editPhoneOptionSecond = 0;
  }

  getDimensionsByFilter(group_id, data){
    return data.filter(x => x.group_id === group_id);
  }

  getAllRealEstateSplitsByTable (document_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('document_id','==',document_id )).valueChanges ();
  }

  updateRealEstateTableData(main_id : '', document_id: any, property: string, event: any, id: '', split_id: '') {
    if(property == 'address'){
      this.showHideLeaderAddressRealestate[main_id] = 1;
    }else if(property == 'asset_value'){
      this.showHideLeaderAssetValueRealestate[main_id] = 1;
    }else if(property == 'ownership_title_name'){
      this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 1;
    }else if(property == 'gross_amount'){
      this.showHideLeaderGrossAmountRealestate[main_id] = 1;
    }else if(property == 'creditor'){
      this.showHideLeaderCreditorRealestate[main_id][id] = 1;
    }else if(property == 'available_redraw'){
      this.showHideLeaderMortgageLimitRealestate[main_id][id] = 1;
    }else if(property == 'current_balance'){
      this.showHideLeaderCurrentBalanceRealestate[main_id][id] = 1;
    }else if(property == 'interest_rate'){
      this.showHideLeaderIntrestRateRealestate[main_id][id] = 1;
    }else if(property == 'interest_rate_term'){
      this.showHideLeaderInterestRateTermRealestate[main_id][id] = 1;
    }else if(property == 'loan_type'){
      this.showHideLeaderLoanTypeRealestate[main_id][id] = 1;
    }else if(property == 'repayments'){
      this.showHideLeaderRepaymentsRealestate[main_id][id] = 1;
    } 
    if(property == 'address' || property == 'asset_value' || property == 'ownership_title_name' || property == 'gross_amount'){
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        'document_id' : document_id,
        'property' : property,
        'value' : event.target.innerText
      }
      var url = this.EnvDataService.EnvData.sendbox_api+"/updateRealEstateByTable";
      this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        if(property == 'address'){
          this.showHideLeaderAddressRealestate[main_id] = 2;
        }else if(property == 'asset_value'){
          this.showHideLeaderAssetValueRealestate[main_id] = 2;
        }else if(property == 'ownership_title_name'){
          this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 2;
        }else if(property == 'gross_amount'){
          this.showHideLeaderGrossAmountRealestate[main_id] = 2;
        } 
        setTimeout(_ => {
          this.showHideLeaderAddressRealestate[main_id] = 0;
          this.showHideLeaderAssetValueRealestate[main_id] = 0;
          this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 0;
          this.showHideLeaderGrossAmountRealestate[main_id] = 0;
        }, 2000);
      }, error => {
        if(property == 'address'){
          this.showHideLeaderAddressRealestate[main_id] = 2;
        }else if(property == 'asset_value'){
          this.showHideLeaderAssetValueRealestate[main_id] = 2;
        }else if(property == 'ownership_title_name'){
          this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 2;
        }else if(property == 'gross_amount'){
          this.showHideLeaderGrossAmountRealestate[main_id] = 2;
        } 
        setTimeout(_ => {
          this.showHideLeaderAddressRealestate[main_id] = 0;
          this.showHideLeaderAssetValueRealestate[main_id] = 0;
          this.showHideLeaderOwnershipTitleNameRealestate[main_id] = 0;
          this.showHideLeaderGrossAmountRealestate[main_id] = 0;
        }, 2000);
      });
    }else{
      let thiss = this;
      var docRef1 = firebase.firestore().collection("SDF_realestate").doc(document_id);
      docRef1.get().then(function(doc) {
        if (doc.exists) {
          let data = doc.data();
          if(property == 'creditor'){
            data.split[id].creditor = event.target.innerText;  
          }else if(property == 'available_redraw'){
            data.split[id].available_redraw = event.target.innerText.split("$").join("").split(",").join("");  
          }else if(property == 'current_balance'){
            data.split[id].current_balance = event.target.innerText.split("$").join("").split(",").join("");  
          }else if(property == 'interest_rate'){
            data.split[id].interest_rate = event.target.innerText.split("%").join("");
          }else if(property == 'interest_rate_term'){
            data.split[id].interest_rate_term = event.target.innerText;  
          }else if(property == 'loan_type'){
            data.split[id].loan_type = event.target.innerText;  
          }else if(property == 'repayments'){
            data.split[id].repayments = event.target.innerText.split("$").join("").split(",").join("");  
          } 
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json' );
          const requestOptions = new RequestOptions({ headers: headers });
          let postData = {
            'document_id' : document_id,
            'property' : property,
            'value' : event.target.innerText,
            'split' : data.split,
            'split_id' : split_id,
            'id' : id
          }
          let url = this.EnvDataService.EnvData.sendbox_api+"/updateRealEstateByTable";
          thiss.http.post(url, postData, requestOptions)
          .subscribe(data => {
            if(property == 'creditor'){
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 2;
            }else if(property == 'available_redraw'){
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 2;
            }else if(property == 'current_balance'){
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 2;
            }else if(property == 'interest_rate'){
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 2;
            }else if(property == 'interest_rate_term'){
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
            }else if(property == 'loan_type'){
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
            }else if(property == 'repayments'){
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 2;
            }
            setTimeout(_ => {
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
            }, 2000);
          }, error => {
            if(property == 'creditor'){
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 2;
            }else if(property == 'available_redraw'){
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 2;
            }else if(property == 'current_balance'){
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 2;
            }else if(property == 'interest_rate'){
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 2;
            }else if(property == 'interest_rate_term'){
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
            }else if(property == 'loan_type'){
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
            }else if(property == 'repayments'){
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 2;
            }
            setTimeout(_ => {
              thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
              thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
              thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
              thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
              thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
              thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
              thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
            }, 2000);
          });
        }
      });
    }
  }

  updateRealEstateTableDataSelect(main_id : '', document_id: any, property: string, event: any, id: '', split_id: '') {
    if(property == 'interest_rate_term'){
      this.showHideLeaderInterestRateTermRealestate[main_id][id] = 1;
    }else if(property == 'loan_type'){
      this.showHideLeaderLoanTypeRealestate[main_id][id] = 1;
    } 
    let thiss = this;
    var docRef1 = firebase.firestore().collection("SDF_realestate").doc(document_id);
    docRef1.get().then(function(doc) {
      if (doc.exists) {
        let data = doc.data();
        if(property == 'interest_rate_term'){
          data.split[id].interest_rate_term = event.target.value;  
        }else if(property == 'loan_type'){
          data.split[id].loan_type = event.target.value;  
        } 
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          'document_id' : document_id,
          'property' : property,
          'value' : event.target.value,
          'split' : data.split,
          'split_id' : split_id,
          'id' : id
        }
        let url = this.EnvDataService.EnvData.sendbox_api+"/updateRealEstateByTable";
        thiss.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if(property == 'interest_rate_term'){
            thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
          }else if(property == 'loan_type'){
            thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
          }
          setTimeout(_ => {
            thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
            thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
            thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
            thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
            thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
            thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
            thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
          }, 2000);
        }, error => {
          if(property == 'interest_rate_term'){
            thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 2;
          }else if(property == 'loan_type'){
            thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 2;
          }
          setTimeout(_ => {
            thiss.showHideLeaderCreditorRealestate[main_id][id] = 0;
            thiss.showHideLeaderMortgageLimitRealestate[main_id][id] = 0;
            thiss.showHideLeaderCurrentBalanceRealestate[main_id][id] = 0;
            thiss.showHideLeaderIntrestRateRealestate[main_id][id] = 0;
            thiss.showHideLeaderInterestRateTermRealestate[main_id][id] = 0;
            thiss.showHideLeaderLoanTypeRealestate[main_id][id] = 0;
            thiss.showHideLeaderRepaymentsRealestate[main_id][id] = 0;
          }, 2000);
        });
      }
    });
  }

  updateTentativeRealEstateTableData(main_id: any, id: any, id1: any, document_id: any, property: string, event: any, split_id: '') {
    if(property == 'address'){
      this.showHideLeaderAddressTentaRealestate[main_id][id] = 1;
    }else if(property == 'asset_value'){
      this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 1;
    }else if(property == 'ownership_title_name'){
      this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 1;
    }else if(property == 'gross_amount'){
      this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 1;
    }else if(property == 'creditor'){
      this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'available_redraw'){
      this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'current_balance'){
      this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'interest_rate'){
      this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'interest_rate_term'){
      this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'loan_type'){
      this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'repayments'){
      this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 1;
    } 

    if(property == 'address' || property == 'asset_value' || property == 'ownership_title_name' || property == 'gross_amount'){
      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json' );
      const requestOptions = new RequestOptions({ headers: headers });
      let postData = {
        'document_id' : document_id,
        'property' : property,
        'value' : event.target.innerText
      }
      let url = this.EnvDataService.EnvData.sendbox_api+"/updateTentativeRealEstateByTable";
      this.http.post(url, postData, requestOptions)
      .subscribe(data => {
        this.showCurrentTentativetable = true;
        this.showCurrentTentativetableIndex = main_id;

        if(property == 'address'){
          this.showHideLeaderAddressTentaRealestate[main_id] = 2;
        }else if(property == 'asset_value'){
          this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 2;
        }else if(property == 'ownership_title_name'){
          this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 2;
        }else if(property == 'gross_amount'){
          this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 2;
        } 
        setTimeout(_ => {
          this.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
          this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
          this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
          this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
          this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
        }, 2000);

      }, error => {
        this.showCurrentTentativetable = true;
        this.showCurrentTentativetableIndex = main_id;

        setTimeout(_ => {
          this.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
          this.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
          this.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
          this.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
          this.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
          this.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
        }, 2000);
      });
    }else{
      let thiss = this;
      var docRef1 = firebase.firestore().collection("tentative_real_estate").doc(document_id);
      docRef1.get().then(function(doc) {
        if (doc.exists) {
          let data = doc.data();
          if(property == 'creditor'){
            data.split[id1].creditor = event.target.innerText;  
          }else if(property == 'available_redraw'){
            data.split[id1].available_redraw = event.target.innerText.split("$").join("").split(",").join("");  
          }else if(property == 'current_balance'){
            data.split[id1].current_balance = event.target.innerText.split("$").join("").split(",").join("");  
          }else if(property == 'interest_rate'){
            data.split[id1].interest_rate = event.target.innerText.split("%").join("");
          }else if(property == 'interest_rate_term'){
            data.split[id1].interest_rate_term = event.target.innerText;  
          }else if(property == 'loan_type'){
            data.split[id1].loan_type = event.target.innerText;  
          }else if(property == 'repayments'){
            data.split[id1].repayments = event.target.innerText.split("$").join("").split(",").join("");  
          } 
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json' );
          const requestOptions = new RequestOptions({ headers: headers });
          let postData = {
            'document_id' : document_id,
            'property' : property,
            'value' : event.target.innerText,
            'split' : data.split,
            'split_id' : split_id,
            'id' : id
          }
          let url = this.EnvDataService.EnvData.sendbox_api+"/updateTentativeRealEstateByTable";
          thiss.http.post(url, postData, requestOptions)
          .subscribe(data => {
            thiss.showCurrentTentativetable = true;
            thiss.showCurrentTentativetableIndex = main_id;

            if(property == 'creditor'){
              thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'available_redraw'){
              thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'current_balance'){
              thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'interest_rate'){
              thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'interest_rate_term'){
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'loan_type'){
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 2;
            }else if(property == 'repayments'){
              thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 2;
            } 

            setTimeout(_ => {
              thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
            }, 2000);
            

          }, error => {
            thiss.showCurrentTentativetable = true;
            thiss.showCurrentTentativetableIndex = main_id;

            setTimeout(_ => {
              thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
              thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
              thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
            }, 2000);

          });
        }
      });
    }
  }


  updateTentaRealEstateTableDataSelect(main_id: any, id: any, id1: any, document_id: any, property: string, event: any, split_id: '') {
    if(property == 'interest_rate_term'){
      this.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 1;
    }else if(property == 'loan_type'){
      this.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 1;
    } 
    let thiss = this;
    var docRef1 = firebase.firestore().collection("tentative_real_estate").doc(document_id);
    docRef1.get().then(function(doc) {
      if (doc.exists) {
        let data = doc.data();
        if(property == 'interest_rate_term'){
          data.split[id1].interest_rate_term = event.target.value;  
        }else if(property == 'loan_type'){
          data.split[id1].loan_type = event.target.value;  
        } 
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          'document_id' : document_id,
          'property' : property,
          'value' : event.target.value,
          'split' : data.split,
          'split_id' : split_id,
          'id' : id
        }
        let url = this.EnvDataService.EnvData.sendbox_api+"/updateTentativeRealEstateByTable";
        thiss.http.post(url, postData, requestOptions)
        .subscribe(data => {
          thiss.showCurrentTentativetable = true;
          thiss.showCurrentTentativetableIndex = main_id;
          if(property == 'interest_rate_term'){
            thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 2;
          }else if(property == 'loan_type'){
            thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 2;
          }
          setTimeout(_ => {
            thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
          }, 2000);
        }, error => {
          thiss.showCurrentTentativetable = true;
          thiss.showCurrentTentativetableIndex = main_id;
          setTimeout(_ => {
            thiss.showHideLeaderAddressTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderAssetValueTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderOwnershipTitleTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderGrossAmountTentaRealestate[main_id][id] = 0;
            thiss.showHideLeaderCreditorTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderMortgageLimitTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderCurrentBalanceTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderIntrestRateTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderInterestRateTermTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderLoanTypeTentaRealestate[main_id][id][id1] = 0;
            thiss.showHideLeaderRepaymentsTentaRealestate[main_id][id][id1] = 0;
          }, 2000);
        });
      }
    });
  }

  changeValue(id: number, property: string, event: any) {
    //this.editField = event.target.textContent;
  }
  
  hideShowTableView(i, status){
    if(status){
      this.showHideTentativetable[i] = false;
    }else{
      this.showHideTentativetable[i] = true;
    }    
  }

  unapproved(firstname, lastname){
    let uid = window.localStorage.getItem("uid");
    let brokerName = window.localStorage.getItem("brokerFirstname")+' '+window.localStorage.getItem("brokerLastname");
    this.userRole = window.localStorage.getItem("userRole");
    let alert = this.alertCtrl.create({
      title: 'Are you sure',
      message: 'Do you want to reset the customer approval of this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(this.contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let priSec_uid = '';
                  if(this.priSec_uid != null){
                    priSec_uid = this.priSec_uid;
                  }
                  let pri_contact_uid = this.contact_uid;
                  if(this.user_data.contact_type != 'Primary Contact'){
                    pri_contact_uid = this.priSec_uid;
                  }
                  let ckuserRole = 'Broker';
                  if(this.userRole == 'super_admin'){
                    ckuserRole = 'Super Admin';
                  }else if(this.userRole == 'loan_admin'){
                    ckuserRole = 'Loan Admin';
                  }
                  let postData = {
                    'contact_uid' : this.contact_uid,
                    'priSec_uid' : priSec_uid,
                    "created_date" : new Date().getTime(),
                    "contact_type" : this.user_data.contact_type,
                    "pri_contact_uid" : pri_contact_uid,
                    "brokerName" : brokerName,
                    "userRole" : ckuserRole,
                    "user_history_created_by": uid,
                    "name": firstname +' '+ lastname,
                    "SDF_form_document_id": this.SDF_form_document_id
                  }
                  let url = this.EnvDataService.EnvData.sendbox_api+"/unapprovedSubmittion";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'error'){
                      this.presentToast('Something went wrong please try again later.');
                    }else{
                      this.presentToast('Reset customer approval successfully.');
                      this.user_data.accessGrantedFromUser = 0;
                      postData['ip_address'] = data['_body'];
                      postData['status'] = 5;
                      this.user_history_data(postData)
                    }
                    this.loadingProvider.stopLoading();
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }

  resetAllPremission(){
    let brokerName = window.localStorage.getItem("brokerFirstname")+' '+window.localStorage.getItem("brokerLastname");
    this.userRole = window.localStorage.getItem("userRole");
    let alert = this.alertCtrl.create({
      title: 'Are you sure',
      message: 'Do you want to reset the customer permission of this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(this.contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let priSec_uid = '';
                  if(this.priSec_uid != null){
                    priSec_uid = this.priSec_uid;
                  }
                  let pri_contact_uid = this.contact_uid;
                  if(this.user_data.contact_type != 'Primary Contact'){
                    pri_contact_uid = this.priSec_uid;
                  }
                  let ckuserRole = 'Broker';
                  if(this.userRole == 'super_admin'){
                    ckuserRole = 'Super Admin';
                  }else if(this.userRole == 'loan_admin'){
                    ckuserRole = 'Loan Admin';
                  }
                  let postData = {
                    'contact_uid' : this.contact_uid,
                    'priSec_uid' : priSec_uid,
                    "created_date" : new Date().getTime(),
                    "contact_type" : this.user_data.contact_type,
                    "pri_contact_uid" : pri_contact_uid,
                    "brokerName" : brokerName,
                    "userRole" : ckuserRole
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/resetAllPremission";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Reset customer permission successfully.');
                      this.user_data.allowCustoViewOnlyPermission = 0;
                      this.user_data.allowCustoeditPermission = 0;
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }

  uploadImage(event, uid) {
    if(this.all_documents.length == 0){
      this.all_documents = this.user_data.all_documents;
    }
    
    
    if(this.all_documents == undefined){
      this.all_documents = [];
    }
    
    
    if (event.target.files && event.target.files[0]) {
      let document_name = event.target.name;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      // For Preview Of Image
      reader.onload = (e:any) => { // called once readAsDataURL is completed
        this.url = e.target.result;
        // For Uploading Image To Firebase
        const fileraw = event.target.files[0];
        const filePath = '/User Documents/' + uid + '/' + document_name + '_' + (Math.floor(1000 + Math.random() * 9000) + 1);
        const result = this.SaveImageRef(filePath, fileraw);
        const ref = result.ref;
        this.percentage = result.task.percentageChanges();
        this.percentageArea = document_name;
        result.task.then(a => {
          ref.getDownloadURL().subscribe(a => {
            let status_url = 0;
            if(this.all_documents.length > 0){
              for(let i = 0; i < this.all_documents.length; i++){
                if(this.all_documents[i].name == document_name){
                  this.all_documents[i].url = a;
                  status_url = 1;
                }
              }
            }
            if(status_url == 0){
              this.all_documents.push({'name': document_name, 'url': a});
            }
            var headers = new Headers();
            headers.append("Accept", 'application/json');
            headers.append('Content-Type', 'application/json' );
            const requestOptions = new RequestOptions({ headers: headers });
            let postData = {
              'contact_uid' : uid,
              'document_name' : document_name,
              'document_url' : a
            }
            let url = this.EnvDataService.EnvData.sendbox_api+"/emailDocumentUploadByContact";
            this.http.post(url, postData, requestOptions)
            .subscribe(data => {
              this.presentToast('Document uploaded successfully.');
            }, error => {
              this.presentToast(error.message);      
            });
            this.db.collection('users').doc(uid).update({
              all_documents: this.all_documents
            });
            this.user_data.all_documents = this.all_documents;
          });
        });
      }, error => {
        console.log(error);
      }

    }
  }
  SaveImageRef(filePath, file) {

    return {
      task: this.storage.upload(filePath, file), 
      ref: this.storage.ref(filePath)
    };
  }

  viewUserHistory(event, document_id){
    let viewUserHistory = this.modalCtrl.create(HistoryDetailsPage, {
      "document_id": document_id,
      "SDF_form_document_id": this.SDF_form_document_id
    });

    viewUserHistory.present();
  }

  viewMoreAddress(user_data){
    let viewMoreAddress = this.modalCtrl.create(ViewMoreAddressPage, {
      "user_data": user_data
    });

    viewMoreAddress.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-contact/view-contact.ts